import { Sentiment } from '../central/constants/sentiment';
import type { TSentimentBuckets } from '../central/types/intelligence.type';

// Tie-break order for the dominant bucket: a tie between unhappy and happy reads
// as unhappy, and neutral only wins when it is strictly the largest.
const DOMINANT_SENTIMENT_ORDER: readonly Sentiment[] = [
  Sentiment.Unhappy,
  Sentiment.Happy,
  Sentiment.Neutral,
];

/**
 * The sentiment bucket holding the most classified questions, used by the Home
 * Intelligence hero card for its headline and its quoted question. Shared so the
 * backend (which bucket to quote) and the frontend (headline and colour) agree.
 * Returns null when nothing is classified.
 */
export const resolveDominantSentiment = (
  buckets: TSentimentBuckets,
): Sentiment | null => {
  if (buckets.total === 0) {
    return null;
  }

  let dominant: Sentiment | null = null;
  let dominantCount = 0;
  for (const sentiment of DOMINANT_SENTIMENT_ORDER) {
    const count = buckets[sentiment];
    if (count > dominantCount) {
      dominant = sentiment;
      dominantCount = count;
    }
  }

  return dominant;
};
